import PropTypes from 'prop-types'
import React, { useEffect, useRef } from 'react'

import SimpleBar from 'simplebar-react'

import MetisMenu from 'metismenujs'
import { withRouter, Link, NavLink } from 'react-router-dom'
import './styles.css'
import './sidebar-modern.css'
import { withTranslation } from 'react-i18next'
import { useUserInfo } from 'context/userContext'
import BrandWordmark from '../Common/BrandWordmark'
import ProfileMenu from '../CommonForBoth/TopbarDropdown/ProfileMenu'
import {
  BarChart2,
  ChevronDown,
  Clipboard,
  CreditCard,
  FileText,
  Layout,
  Send,
  Shield,
  ShoppingBag,
  Sliders,
  Smartphone,
  Users,
  Zap
} from 'react-feather'

const planosAutorizacao = [
  {
    plano: 'BASIC',
    autorizacao: {
      dashboard: true,
      disparador: true,
      envio_simplificado: true,
      meuChat: true,
      copyrigth: false,
      grupos: false,
      meusWhatsapp: true,
      tutorial: true,
      planos: true
    }
  },
  {
    plano: 'STANDARD',
    autorizacao: {
      dashboard: true,
      disparador: true,
      envio_simplificado: true,
      meuChat: true,
      copyrigth: true,
      grupos: true,
      meusWhatsapp: true,
      tutorial: true,
      planos: true
    }
  },
  {
    plano: 'PREMIUM',
    autorizacao: {
      dashboard: true,
      disparador: true,
      envio_simplificado: true,
      meuChat: true,
      copyrigth: true,
      grupos: true,
      meusWhatsapp: true,
      tutorial: true,
      planos: true
    }
  }
]

const Icon = ({ children }) => (
  <span className="sidebar-nav-link__icon" aria-hidden>
    {children}
  </span>
)

const SidebarContent = (props) => {
  const ref = useRef()
  const { isRoot, userPlan, userId } = useUserInfo()

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300
      }
    }
  }

  function activateParentDropdown(item) {
    item.classList.add('active')
    const parent = item.parentElement
    const parent2El = parent.childNodes[1]
    if (parent2El && parent2El.id !== 'side-menu') {
      parent2El.classList.add('mm-show')
    }

    if (parent) {
      parent.classList.add('mm-active')
      const parent2 = parent.parentElement

      if (parent2) {
        parent2.classList.add('mm-show')

        const parent3 = parent2.parentElement

        if (parent3) {
          parent3.classList.add('mm-active')
          parent3.childNodes[0].classList.add('mm-active')
          const parent4 = parent3.parentElement
          if (parent4) {
            parent4.classList.add('mm-show')
            const parent5 = parent4.parentElement
            if (parent5) {
              parent5.classList.add('mm-show')
              parent5.childNodes[0].classList.add('mm-active')
            }
          }
        }
      }
      scrollElement(item)
      return false
    }
    scrollElement(item)
    return false
  }

  useEffect(() => {
    const pathName = props.location.pathname

    const initMenu = () => {
      new MetisMenu('#side-menu')
      let matchingMenuItem = null
      const ul = document.getElementById('side-menu')
      const items = ul.getElementsByTagName('a')
      for (let i = 0; i < items.length; ++i) {
        if (pathName === items[i].pathname) {
          matchingMenuItem = items[i]
          break
        }
      }
      if (matchingMenuItem) {
        activateParentDropdown(matchingMenuItem)
      }
    }
    initMenu()
  }, [props.location.pathname])

  useEffect(() => {
    ref.current.recalculate()
  })

  function tToggleSidebar() {
    const body = document.body
    if (window.innerWidth <= 992) {
      body.classList.toggle('sidebar-enable')
    } else {
      body.classList.toggle('vertical-collpsed')
      body.classList.toggle('sidebar-enable')
    }
  }

  return (
    <React.Fragment>
      <div className="sidebar-modern-shell">
        <SimpleBar
          className="sidebar-modern-shell__scroll"
          style={{ maxHeight: 'calc(100vh - 108px)' }}
          ref={ref}
        >
          <div className="navbar-brand-box navbar-brand-box--with-toggle">
            <button
              type="button"
              className="sidebar-menu-toggle btn btn-link"
              onClick={tToggleSidebar}
              aria-label="Abrir ou fechar menu"
            >
              <i className="mdi mdi-menu" />
            </button>
            <Link to="/" className="logo logo-dark sidebar-modern-brand flex-grow-1">
              <span className="logo-sm">
                <BrandWordmark size="sm" />
              </span>
              <span className="logo-lg">
                <BrandWordmark size="lg" />
              </span>
            </Link>
            <Link to="/" className="logo logo-light sidebar-modern-brand flex-grow-1">
              <span className="logo-sm">
                <BrandWordmark size="sm" />
              </span>
              <span className="logo-lg">
                <BrandWordmark size="lg" />
              </span>
            </Link>
          </div>
        <div id="sidebar-menu" className="vertical-menu--modern-nav">
          <ul className="metismenu list-unstyled" id="side-menu">
            {planosAutorizacao.filter((plano) => plano?.plano === userPlan)[0]
              ?.autorizacao['dashboard'] && (
              <li>
                <NavLink
                  to="/dashboard"
                  className="sidebar-nav-link waves-effect"
                  activeClassName="sidebar-nav-link--active"
                  exact={true}
                >
                  <Icon>
                    <Layout size={18} strokeWidth={1.75} />
                  </Icon>
                  <span className="sidebar-nav-link__label">
                    {props.t('Dashboard')}
                  </span>
                </NavLink>
              </li>
            )}
            {isRoot ? (
              <li>
                <Link
                  to="/#"
                  className="sidebar-nav-link sidebar-nav-link--parent waves-effect"
                >
                  <Icon>
                    <Shield size={18} strokeWidth={1.75} />
                  </Icon>
                  <span className="sidebar-nav-link__label">
                    {props.t('Root')}
                  </span>
                  <ChevronDown
                    className="sidebar-nav-link__chevron"
                    size={17}
                    strokeWidth={2}
                  />
                </Link>
                <ul className="sub-menu" aria-expanded="true">
                  <li>
                    <NavLink
                      to="/relatorio-financeiro"
                      className="sidebar-nav-link waves-effect"
                      activeClassName="sidebar-nav-link--active"
                      exact={true}
                    >
                      <Icon>
                        <BarChart2 size={17} strokeWidth={1.75} />
                      </Icon>
                      <span className="sidebar-nav-link__label">
                        {props.t('Financeiro')}
                      </span>
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/users"
                      className="sidebar-nav-link waves-effect"
                      activeClassName="sidebar-nav-link--active"
                      exact={true}
                    >
                      <Icon>
                        <Users size={17} strokeWidth={1.75} />
                      </Icon>
                      <span className="sidebar-nav-link__label">
                        {props.t('Usuarios')}
                      </span>
                    </NavLink>
                  </li>
                  {isRoot && (
                    <li>
                      <NavLink
                        to="/planos-personalizados"
                        className="sidebar-nav-link waves-effect"
                        activeClassName="sidebar-nav-link--active"
                        exact={true}
                      >
                        <Icon>
                          <Sliders size={17} strokeWidth={1.75} />
                        </Icon>
                        <span className="sidebar-nav-link__label">
                          {props.t('Planos personalizado')}
                        </span>
                      </NavLink>
                    </li>
                  )}
                  <li>
                    <NavLink
                      to="/logs"
                      className="sidebar-nav-link waves-effect"
                      activeClassName="sidebar-nav-link--active"
                      exact={true}
                    >
                      <Icon>
                        <FileText size={17} strokeWidth={1.75} />
                      </Icon>
                      <span className="sidebar-nav-link__label">
                        {props.t('Logs')}
                      </span>
                    </NavLink>
                  </li>
                </ul>
              </li>
            ) : null}
            <li className="sidebar-section-head sidebar-section-head--after-main">
              <span className="sidebar-section-head__text">
                {props.t('Whatsapp')}
              </span>
            </li>
            <li>
              <NavLink
                to="/enviar-planilha"
                className="sidebar-nav-link waves-effect"
                activeClassName="sidebar-nav-link--active"
                exact={true}
              >
                <Icon>
                  <Send size={18} strokeWidth={1.75} />
                </Icon>
                <span className="sidebar-nav-link__label">
                  {props.t('Disparador')}
                </span>
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/envio-simplificado"
                className="sidebar-nav-link waves-effect"
                activeClassName="sidebar-nav-link--active"
                exact={true}
              >
                <Icon>
                  <Zap size={18} strokeWidth={1.75} />
                </Icon>
                <span className="sidebar-nav-link__label">
                  {props.t('Envio simplificado')}
                </span>
              </NavLink>
            </li>

            {(Number(userId) === 35 || isRoot) && (
              <li>
                <Link
                  to="/#"
                  className="sidebar-nav-link sidebar-nav-link--parent waves-effect"
                >
                  <Icon>
                    <ShoppingBag size={18} strokeWidth={1.75} />
                  </Icon>
                  <span className="sidebar-nav-link__label">
                    {props.t('Mais modas')}
                  </span>
                  <ChevronDown
                    className="sidebar-nav-link__chevron"
                    size={17}
                    strokeWidth={2}
                  />
                </Link>
                <ul className="sub-menu" aria-expanded="true">
                  <li>
                    <NavLink
                      to="/mais-modas-relatorios"
                      className="sidebar-nav-link waves-effect"
                      activeClassName="sidebar-nav-link--active"
                      exact={true}
                    >
                      <Icon>
                        <Clipboard size={17} strokeWidth={1.75} />
                      </Icon>
                      <span className="sidebar-nav-link__label">
                        {props.t('Relatório de clientes')}
                      </span>
                    </NavLink>
                  </li>
                </ul>
              </li>
            )}

            <li className="sidebar-section-head">
              <span className="sidebar-section-head__text">
                {props.t('Minha Conta')}
              </span>
            </li>
            <li>
              <NavLink
                to="/assinaturas"
                className="sidebar-nav-link waves-effect"
                activeClassName="sidebar-nav-link--active"
                exact={true}
              >
                <Icon>
                  <CreditCard size={18} strokeWidth={1.75} />
                </Icon>
                <span className="sidebar-nav-link__label">
                  {props.t('Assinatura')}
                </span>
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/instance"
                className="sidebar-nav-link waves-effect"
                activeClassName="sidebar-nav-link--active"
                exact={true}
              >
                <Icon>
                  <Smartphone size={18} strokeWidth={1.75} />
                </Icon>
                <span className="sidebar-nav-link__label">
                  {props.t('Meus Whatsapp')}
                </span>
              </NavLink>
            </li>
          </ul>
        </div>
        </SimpleBar>
        <div className="sidebar-modern-footer">
          <ProfileMenu variant="sidebar" />
        </div>
      </div>
    </React.Fragment>
  )
}

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any
}

export default withRouter(withTranslation()(SidebarContent))
